import { Audit } from '../interfaces/Audit';

export const getEmptyAudit = (): Audit => ({
  createdAt: new Date(),
  createdBy: '',
});
